import { OverlayWrapper, RotateImage, LoaderIcon } from "./style";

const Loader = ({ show = false }) => {
  if (!show) {
    return <div />;
  }

  return (
    <OverlayWrapper aria-hidden={true}>
      <RotateImage aria-hidden={true}>
        <LoaderIcon />
      </RotateImage>
    </OverlayWrapper>
  );
};

export default Loader;
